export enum CONTRACT_FEATURE_TYPE {
  PREDICTIVE_MAINTENANCE = 'PREDICTIVE_MAINTENANCE',
  WARRANTY_EXTENSION = 'WARRANTY_EXTENSION',
  ADDON_FASTNET = 'ADDON_FASTNET',
  CLOUD_BACKUPS = 'CLOUD_BACKUPS',
  SOFTWARE_UPDATES = 'SOFTWARE_UPDATES',
}
